/* eslint-disable no-unused-vars */
import React, {
  Component,
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import 'formdata-polyfill';

import throttle from 'lodash/throttle';

// ---
import resizing from '../../context/resizing';
import { StyledBox, StyledBoxInner } from './style';
// ---
import HeaderCloseBarNode from './node/HeaderCloseBarNode';
import BodyNode from './node/BodyNode';
import FooterNode from './node/FooterNode';
import HeaderNode from './node/HeaderNode';

/**
 * survey - inquiry section component を作成します
 * @param {boolean} [embedded=false] embedded type flag
 * @param {?function} [onCloseClick=null] close button callback
 * @param {?function} [onSendClick=null] close button callback
 * @param {*} props React.props
 * @return {*} React.node
 * @constructor
 */
const Inquiry = ({
  embedded = false,
  onCloseClick = null,
  onSendClick = null,
  ...props
}) => {
  // resize
  // const { state } = useContext(resizing.Context);
  const resizingContext = useContext(resizing.Context);
  const state =
    resizingContext && resizingContext.state
      ? resizingContext.state
      : resizing.initial;
  // like instance variable
  const setupStyleOnceRef = useRef(false);
  const storedBodyPosition = useRef(null);
  const storedBodyOverflow = useRef(null);
  const storedBodyWidth = useRef(null);
  // ---
  useEffect(() => {
    if (!setupStyleOnceRef.current) {
      setupStyleOnceRef.current = true;
      storedBodyPosition.current = document.body.style.position;
      storedBodyOverflow.current = document.body.style.overflow;
      storedBodyWidth.current = document.body.style.width;
    }
  }, [
    setupStyleOnceRef,
    storedBodyPosition,
    storedBodyOverflow,
    storedBodyWidth,
  ]);
  // ---
  const storedScrollTopRef = useRef(null);
  // element ref
  const scrollerRef = useRef(null);
  const messageRef = useRef(null);
  const textareaRef = useRef(null);
  const footerRef = useRef(null);
  const headerCloseBarRef = useRef(null);
  const scrollTarget = useRef(null);
  const throttleWatchScroll = useRef(null);

  // state
  const [headerHeight, setHeaderHeight] = useState(10);
  const [bodyPadding, setBodyPadding] = useState(72);
  const [headerTopMargin, setHeaderTopMargin] = useState(1);
  const [showCloseBar, setShowCloseBar] = useState(false);

  const { inquiry, inquiryNegative, nps } = props.config;

  // consts
  // ?
  // const isCloseBarAnimationAvailable = false;
  const isCloseBarAnimationAvailable = useCallback(() => {
    return false;
  }, []);
  // フルスクリーン表示になる条件
  // const isFullscreen = inquiry.checkList.available && !state.desktop;
  const isFullscreen = useCallback(() => {
    return inquiry.checkList.available && !state.desktop;
  }, [inquiry, state]);
  // クローズボタンが非表示になる条件
  // const isCloseBtnDisable = isFullscreen() && !isCloseBarAnimationAvailable();
  const isCloseBtnDisable = useCallback(() => {
    return isFullscreen() && !isCloseBarAnimationAvailable();
  }, [isFullscreen, isCloseBarAnimationAvailable]);

  const bodyFixed = useCallback(() => {
    if (inquiry.checkList.available) {
      document.body.style.position = 'fixed';
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    }
  }, [inquiry.checkList.available]);

  const storeScrollTop = useCallback(() => {
    storedScrollTopRef.current =
      window.pageYOffset || document.documentElement.scrollTop;
  }, [storedScrollTopRef]);

  const shouldRestoreBodyStyle = useCallback(() => {
    if (document.body.style.position === 'fixed') {
      document.body.style.position = storedBodyPosition.current;
      document.body.style.overflow = storedBodyOverflow.current;
      document.body.style.width = storedBodyWidth.current;
      if (storedScrollTopRef.current) {
        window.scrollTo(0, storedScrollTopRef.current);
      }
    }
  }, [
    storedBodyPosition,
    storedBodyOverflow,
    storedScrollTopRef,
    storedBodyWidth,
  ]);

  // ------
  const onCloseAction = useCallback(() => {
    // console.log('Inquiry - onCloseAction', document.body.style.position, storedBodyPosition)
    if (typeof onCloseClick === 'function') {
      onCloseClick.call(this);
    }
    shouldRestoreBodyStyle();
  }, [onCloseClick, shouldRestoreBodyStyle]);
  // ------
  const onSendAction = useCallback(
    textRef => {
      if (typeof onSendClick === 'function') {
        onSendClick.call(this, textRef);
      }
      shouldRestoreBodyStyle();
    },
    [onSendClick, shouldRestoreBodyStyle]
  );
  // ------

  // スクロールのスレショルド
  const scrollThreshold = 30;
  //  スクロールを監視して HeaderCloseBar の show/hide を設定する
  const watchScroll = useCallback(() => {
    if (scrollTarget.current) {
      const { scrollTop } = scrollTarget.current;
      const b = isFullscreen() && scrollTop > scrollThreshold;
      setShowCloseBar(b);
    }
  }, [isFullscreen, setShowCloseBar, scrollTarget]);
  // スロットル
  throttleWatchScroll.current = throttle(watchScroll, 100);

  // mobile: window.matchMedia(`(min-width:${BreakPoint.desktop})`).matches === false
  // willUnmount callback
  // @see https://ja.reactjs.org/docs/hooks-reference.html#usecallback
  const cleanupWithUnmount = useCallback(() => {
    shouldRestoreBodyStyle();
  }, [shouldRestoreBodyStyle]);

  // ----
  // @since 20200120
  // callback 化します
  const shouldSetHeaderHeight = useCallback(() => {
    // console.log('shouldSetHeaderHeight', messageRef.current, headerHeight)
    if (messageRef.current) {
      const messageHeight = messageRef.current.clientHeight;
      if (messageHeight !== headerHeight) {
        setHeaderHeight(messageHeight);
      }
    }
  }, [messageRef, headerHeight, setHeaderHeight]);
  // ----

  const timerSetHeaderRef = useRef(0);

  // mobile: window.matchMedia(`(min-width:${BreakPoint.desktop})`).matches === false
  // didMount / willUnmount
  // @see https://ja.reactjs.org/docs/hooks-reference.html#useeffect
  useEffect(() => {
    clearTimeout(timerSetHeaderRef.current);
    if (!state.desktop) {
      storeScrollTop();
      bodyFixed();
      timerSetHeaderRef.current = setTimeout(shouldSetHeaderHeight, 500);
      // shouldSetHeaderHeight()
    } else {
      shouldRestoreBodyStyle();
      storedScrollTopRef.current = null;
    }

    // will unmount
    return cleanupWithUnmount;
  }, [
    cleanupWithUnmount,
    bodyFixed,
    storeScrollTop,
    shouldRestoreBodyStyle,
    state.desktop,
    shouldSetHeaderHeight,
    timerSetHeaderRef,
  ]);

  // 有効ではなかったのでコメントにする
  // // didUpdate - with inquiry.question, messageRef, headerHeight
  // useEffect(() => {
  //   // if (messageRef.current) {
  //   // const messageHeight = messageRef.current.clientHeight;
  //   // if (messageHeight !== headerHeight) {
  //   //   setHeaderHeight(messageHeight);
  //   // }
  //   // }
  //   shouldSetHeaderHeight();
  // }, [
  //   // inquiry.checkList.question,
  //   // messageRef,
  //   // headerHeight,
  //   // inquiry.checkList.available,
  //   // state.width,
  //   shouldSetHeaderHeight,
  // ]);

  // footer button の高さが固定では無いので desktop の inline scroll で textarea を見きれないように padding-bottom を footer height 分与える
  useEffect(() => {
    if (footerRef.current) {
      const footerHeight = footerRef.current.getBoundingClientRect().height;
      // console.log('footerRef.current.clientHeight', footerRef.current, footerHeight)
      if (bodyPadding !== footerHeight) {
        setBodyPadding(footerHeight);
      }
    }
  }, [bodyPadding, inquiry.sendBtnTxt, state.width]);

  // didMount/didUpdate
  // RefからHeaderCloseBarコンポーネントの高さを取得してstateに設定する
  // useEffect(() => {
  //   console.log('Inquiry.useEffect headerCloseBarRef.current', headerCloseBarRef.current && headerCloseBarRef.current.clientHeight)
  //   const headerCloseBarHeight =
  //     !isCloseBarAnimationAvailable() && headerCloseBarRef.current
  //       ? headerCloseBarRef.current.clientHeight
  //       : 1;
  //   // ヘッダのトップマージンにHeaderCloseBarコンポーネントの高さを設定し、位置を確保する
  //   setHeaderTopMargin(headerCloseBarHeight);
  // }, [isCloseBarAnimationAvailable, headerCloseBarRef]);
  useEffect(() => {
    const headerCloseBarHeight =
      headerCloseBarRef.current && isFullscreen()
        ? headerCloseBarRef.current.clientHeight
        : 1;
    setHeaderTopMargin(headerCloseBarHeight);
  }, [isFullscreen, headerCloseBarRef]);

  // phase 1 からコピーした - 何をしているかわからないので一旦コメントにする
  // // didUpdate - with props.forceScroll, scrollerRef
  // useEffect(() => {
  //   if (props.forceScroll && scrollerRef.current) {
  //     scrollerRef.current.scrollTo(0, scrollerRef.current.clientHeight);
  //   }
  // }, [props.forceScroll, scrollerRef]);

  /**
   * props.config の値が変わったら shouldSetHeaderHeight を行う
   * */
  useEffect(() => {
    // console.log('Inquiry - props.config', props.config)
    shouldSetHeaderHeight();
  }, [props.config, shouldSetHeaderHeight]);

  return (
    <StyledBox
      className={`${props.className ? props.className : ''} Inquiry`}
      headerHeight={headerHeight}
      checkList={inquiry.checkList.available}
      embedded={embedded}
    >
      <StyledBoxInner
        className={'StyledBoxInner'}
        innerRef={scrollTarget}
        onScroll={throttleWatchScroll.current}
      >
        {/* header close bar - Fullscreen (Mobile w/Checkbox) only */}
        <HeaderCloseBarNode
          // action={props.onCloseClick}
          action={onCloseAction}
          headerCloseBarRef={headerCloseBarRef}
          isFullscreen={isFullscreen()}
          isCloseBarAnimationAvailable={isCloseBarAnimationAvailable()}
          showCloseBar={showCloseBar}
          embedded={embedded}
          {...props}
        />
        {/* header */}
        <HeaderNode
          headerHeight={headerHeight}
          headerTopMargin={isFullscreen ? headerTopMargin : 0}
          messageRef={messageRef}
          inquiry={inquiry}
          isCloseBtnDisable={isCloseBtnDisable()}
          // action={props.onCloseClick}
          action={onCloseAction}
          isFullscreen={isFullscreen()}
          embedded={embedded}
          {...props}
        />
        {/* body */}
        <BodyNode
          scrollerRef={scrollerRef}
          headerHeight={headerHeight}
          bodyPadding={bodyPadding}
          inquiry={inquiry}
          nps={nps}
          inquiryNegative={inquiryNegative}
          textareaRef={textareaRef}
          embedded={embedded}
        />
        {/* footer */}
        <FooterNode
          // action={props.onSendClick}
          action={onSendAction}
          textareaRef={textareaRef}
          footerRef={footerRef}
          inquiry={inquiry}
          embedded={embedded}
        />
      </StyledBoxInner>
    </StyledBox>
  );
};

export default Inquiry;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/Inquiry.js